module.exports = __webpack_public_path__ + "img/bank-bca.233c7f89.png";